import { isDevMode } from '@angular/core';
import { provideClarity } from 'ngx-clarity';

export const CLARITY_PROVIDER = provideClarity({
  enabled: !isDevMode(),
  projectId: 'qjnqj0ux1u',
});
